'use client'

import { sortBy } from 'lodash'

import { AccountNetworksList } from '~/components/AccountNetworksList'
import { SignersList } from '~/components/SignersList'
import { SplitsDialogContent } from '~/components/component-library/Dialog'
import { useActiveOrg } from '~/hooks/org'
import { useOrgSmartAccount } from '~/hooks/useSmartAccounts'
import { IAddress } from '~/types'

export const DetailDialogContent = ({ address }: { address: IAddress }) => {
  const { smartAccount } = useOrgSmartAccount(address)
  const { org } = useActiveOrg()

  const passkeySigners = smartAccount
    ? sortBy(smartAccount.signers, 'user.email')
    : []
  const eoaSigners = smartAccount
    ? sortBy(smartAccount.eoaSigners, 'address')
    : []

  return (
    <SplitsDialogContent
      id="smartAccountDetails"
      title={`${smartAccount?.name ?? 'Account details'}`}
      variant="info"
    >
      {smartAccount && (passkeySigners.length > 0 || eoaSigners.length > 0) && (
        <SignersList
          header="Signers"
          signers={passkeySigners}
          eoaSigners={eoaSigners}
          threshold={smartAccount.threshold}
          initialExpanded={org?.members.length === 1}
        />
      )}
      <AccountNetworksList address={address} />
    </SplitsDialogContent>
  )
}
